import { useNotify } from '@globaleris/ui.library'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core'
import DOMPurify from 'dompurify'
import PostHTML from 'posthtml'
import Quill from 'quill'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import RichTextEditor from '../../../richTextEditor/richTextEditor'

const MAX_LENGTH = 1000
export interface CommentFabProps {
  isOpen: boolean
  onCloseModal: () => void
  onSaveComment: (textComment: string) => void
}

export const CommentModal: React.FC<CommentFabProps> = ({
  isOpen,
  onCloseModal,
  onSaveComment
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'tasks', 'enums'])
  const { info, error } = useNotify()

  const quillRef = useRef<Quill | null>(null)

  // #region Handlers Starts

  const handleSaveComment = () => {
    //check content length
    const contentLength = quillRef.current?.root?.innerHTML?.length ?? 0
    const isEmpty = quillRef.current?.getText().trim().length === 0

    if (!quillRef.current) {
      error(t('tasks:fetchResponse.createTaskComment.editorNotReady'))
      return
    }

    if (isEmpty) {
      error(t('tasks:fetchResponse.createTaskComment.emptyComment'))
      return
    }

    if (contentLength > MAX_LENGTH) {
      error(t('tasks:fetchResponse.createTaskComment.maxCharError'))
      return
    }

    onCloseModal()

    // brute HTML from quill
    const html = quillRef.current?.root.innerHTML || ''

    // clean HTML inmediately with DOMPurify to prevent XSS attacks
    const cleanHtml = DOMPurify.sanitize(html)

    // use posthtml to semantize the HTML - quill 2.0 use getSemanticHTML() method
    PostHTML()
      .process(cleanHtml)
      .then(result => {
        const semantizedHtml = result.html
        onSaveComment(semantizedHtml) // save comment with clean&safe HTML
      })
      .catch(err => {
        error(t('tasks:fetchResponse.createTaskComment.processingError'))
      })
  }
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <>
      <Dialog fullWidth maxWidth="md" open={isOpen} onClose={onCloseModal}>
        <DialogTitle>
          <Typography variant="h5">{t('tasks:components.commentListCard.fab.title')}</Typography>
        </DialogTitle>
        <DialogContent>
          <RichTextEditor ref={quillRef} height="350px" />
        </DialogContent>
        <DialogActions>
          <Button size="small" color="inherit" onClick={onCloseModal}>
            {t('tasks:components.commentListCard.mainAction.cancel')}
          </Button>
          <Button size="small" color="primary" onClick={handleSaveComment}>
            {t('tasks:components.commentListCard.mainAction.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
